<div class="bloc-content-body" id="account-information">
  @if (form && departments.length > 0) {
    <form class="form w-100" [formGroup]="form" (ngSubmit)="submit()">
      <div class="bloc-input civility">
        <p class="headline">Civilité<sup>*</sup></p>
        <div class="grid">
          <label for="radioMme">
            <input id="radioMme" type="radio" name="civility" value="Mme" formControlName="civility" />
            Madame
          </label>
          <label for="radioMr">
            <input id="radioMr" type="radio" name="civility" value="Mr" formControlName="civility" />
            Monsieur
          </label>
        </div>
      </div>
      <div class="bloc-input">
        <label for="lastName">Nom<sup>*</sup></label>
        <input
          type="text"
          id="lastName"
          name="lastName"
          formControlName="lastName"
          autocomplete="family-name"
          placeholder="Votre nom"
          maxlength="18"
          required
          />
        @if (formSubmitted && getError('lastName')) {
          <small class="error-message">
            {{ getError('lastName') }}
          </small>
        }
      </div>
      <div class="bloc-input">
        <label for="firstName">Prénom<sup>*</sup></label>
        <input
          type="text"
          id="firstName"
          name="firstName"
          formControlName="firstName"
          autocomplete="first-name"
          placeholder="Votre prénom"
          maxlength="18"
          required
          />
        @if (formSubmitted && getError('firstName')) {
          <small class="error-message">
            {{ getError('firstName') }}
          </small>
        }
      </div>
      <div class="bloc-input">
        <label for="email">Adresse e-mail<sup>*</sup></label>
        <input
          type="text"
          id="email"
          name="email"
          formControlName="email"
          placeholder="Votre adresse e-mail"
          required
          />
        @if (formSubmitted && getError('email')) {
          <small class="error-message">
            {{ getError('email') }}
          </small>
        }
      </div>
      <div class="bloc-input">
        <label class="label-margin mb-2">Date de naissance<sup>*</sup>(JJ/MM/AAAA)</label>
        <mat-form-field>
          <input
            matInput
            class="form-control form-full-width"
            (dateChange)="handleManualInput(pickerInput.value)"
            [matDatepicker]="picker"
            [max]="startDate"
            [min]="endDate"
            #pickerInput
            >
          <mat-datepicker-toggle matSuffix [for]="picker">
            <mat-icon id="calendar-icon" svgIcon="agenda" matDatepickerToggleIcon></mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        @if (formSubmitted && getError('birthDate')) {
          <small class="error-message">
            {{ getError('birthDate') }}
          </small>
        }
        @if (formSubmitted && invalidBirthDate) {
          <small class="error-message">
            La date de naissance est invalide.
          </small>
        }
      </div>
      <div class="bloc-input department">
        <label for="birthDepartment">Département de naissance<sup>*</sup></label>
        <select type="text" class="form-control" formControlName="birthDepartment" id="birthDepartment" required>
          <option [value]="null">Choisir un département</option>
          @for (department of departments; track department) {
            <option [value]="department.id">
              {{ department.code }} - {{department.name}}
            </option>
          }
        </select>
        @if (formSubmitted && getError('birthDepartment')) {
          <small class="error-message">
            {{ getError('birthDepartment') }}
          </small>
        }
      </div>
      <div class="bloc-input">
        <label for="phoneNumber">N° de téléphone<sup>*</sup></label>
        <input
          type="text"
          id="phoneNumber"
          name="phoneNumber"
          formControlName="phoneNumber"
          placeholder="Votre numéro de téléphone fixe ou mobile"
          required
          />
        @if (formSubmitted && getError('phoneNumber')) {
          <small class="error-message">
            {{ getError('phoneNumber') }}
          </small>
        }
      </div>
      @if (displayPromo) {
          <div class="bloc-input civility">
              <div class="grid">
                  <label for="promo">
                      <input id="promo" type="checkbox" [checked]="acceptPromo" (click)="setPromoResponse($event)" style="height: 23px !important;"/>
                      En cochant cette case j'accepte l'activation de l'option promo Algérie pour 1€ le premier mois puis 10€.
                  </label>
              </div>
          </div>
      }
      <div class="row w-100 pt-3 text-center">
        <div class="col-12 w-100 cta_container">
          <button type="submit" class="cta_btn level_2 column">Valider<span></span></button>
        </div>
      </div>
    </form>
  }
</div>
